import {createFileRoute} from '@tanstack/react-router';

import {EditReimbursementPage} from '@/modules/reimbursements/pages/EditReimbursementPage';

const RouteComponent = () => {
  const {reimbursementId} = Route.useParams();
  return <EditReimbursementPage reimbursementId={reimbursementId} />;
};

export const Route = createFileRoute('/_authenticated/reimbursements/$reimbursementId_/edit')({
  component: RouteComponent,
});
